import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'core/hoc';
// Import icons by individual modules for better code splitting
import { default as ShareIcon } from 'core/icons/Share';
import {
	ShareBtn,
	Links,
	Wrapper,
} from './shareStyles';
import loadable from '@loadable/component';
import Spinner from 'core/components/Spinner';
const ShareFlyoverContent = loadable(() => import('./ShareFlyoverContent'), {
	fallback: <Spinner size="lg" center style={{ marginTop: 24 }} />
});

const Share = ({ url }) => (
	<Toggle>
		{({ on, toggle, wrapper }) => (
			<Wrapper>
				<ShareBtn onClick={toggle} >
					<ShareIcon />
				</ShareBtn>
				<Links isOn={on} ref={wrapper}>
					{on && (<ShareFlyoverContent url={url} />)}
				</Links>
			</Wrapper>
		)}
	</Toggle>
);

Share.propTypes = {
	url: PropTypes.string,
};

export default Share;
